/**
 * created by xcc
 BatchAudit
 *
 */
import React, {Component} from 'react';
import {Button, Modal, Progress} from "antd";
import {activiti, Activiti} from "../Activity";
import ActivitiModal from "../ActivityModal";

export const BatchButtonList = ({topBtnHeight, activityOption}) => {
    return (
        <div style={{
            height: topBtnHeight,
            padding: '0 20px',
            color: '#fff',
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <ActivityBtn activityOption={activityOption}/>
        </div>
    )
};

const ActivityBtn = ({activityOption}) => {
    return (
        <>
            <ActivitiModal
                {
                    ...activityOption
                }
            />
        </>
    )
};

export default class BatchAudit extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            hideBtn: props.hideBtn,
            batchParams: props.batchParams,
            uuidAuditData: {},
            textareaModalVisible: false,
            inputText: '',
            id: ""
        }
    }

    show() {
        this.setState({hideBtn: false});
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    bachTaskBefore = () => {
        let {batchParams: {handleData}} = this.state;
        if(typeof handleData === "function") {
            handleData((data) => {
                this.batchTask(data)
            });
        }else {
            this.batchTask();
        }
    }

    batchTask = (data) => {
        let that = this;
        let {batchParams: {btnItem, refreshList, checkForm, getCheckedData}} = that.state;
        let checkedData = data ? data : getCheckedData();  //拿到选中的数据
        if (!checkForm()) {
            return;
        }
        let params = {};
        for (let i = 0; i < checkedData.length; i++) {
            params[checkedData[i].id] = checkedData[i];
        }
        that.state.uuidAuditData = params;
        that.state.stepVisible = true;
        let step = checkedData.length;
        let percent = 0;
        that.setState({
            step,
            percent,
        });
        let dealCount = 0;
        let failCount = 0;
        let failInfo = "";
        activiti.batchStart(params, activiti.options, activiti, btnItem, that.saveEveryOneFunction.bind(that), that.updateStatusFunction.bind(that), that.beforeEveryOneStartActiviti.bind(that), function (msgRes) {
            if (msgRes) {
                //设置进度条，
                dealCount++;
                if (msgRes.code === -1) {
                    failCount++;
                    failInfo += that.state.uuidAuditData[msgRes.uuid].name + ";";
                    console.log("error" + msgRes.uuid + msgRes.msg);
                }
                let percent = Math.ceil((dealCount / step) * 100);
                that.setState({
                    percent,
                });
            } else {
                console.log("error")
            }
        }, function (resRes) {
            if (resRes && resRes.code === 1) {
                window.loading.hide();
                that.setState({
                    stepVisible: false
                });
                let content = "总共审核" + step + "条，操作成功" + dealCount + "条,操作失败" + failCount + '条'
                if (failInfo) {
                    content += "[" + failInfo + "}";
                }
                Modal.success({
                    title: resRes.msg,
                    content: content,
                    afterClose() {

                    },
                    onOk() {
                        refreshList();  //刷新列表
                    }
                });
            } else {
                //错误提示
                Modal.error({
                    content: resRes.msg,
                });
            }
        })
    }

    saveEveryOneFunction = (activiti, call, data) => {
        let {batchParams: {saveFunction}} = this.state;
        saveFunction(activiti, (res) => {
            if (res && res.id) {
                this.state.id = res.id;
                this.setState({});
                call(res)
            } else {
                activiti.load.end();
            }
        }, data)
    }

    /**
     * 修改状态方法
     * @param activiti
     */
    updateStatusFunction = (statusName, activiti, call) => {
        let {batchParams: {saveStatusNameFunction}, id} = this.state;
        saveStatusNameFunction(statusName, activiti, call, id)
    }

    /**
     * 流程初始化前，调用的方法，
     * @param activiti
     */
    beforeEveryOneStartActiviti = (id) => {
        let that = this;
        let {batchParams: {setData}} = that.state;
        if(typeof setData === "function") {
            let data = this.state.uuidAuditData[id];
            setData(data)
        }
    }

    render() {
        let {batchParams: {activityTypeName}} = this.state;
        return (
            <>
                {this.state.hideBtn ? "" :
                    <Button
                        style={{marginLeft: "24px"}}
                        type={"primary"}
                        onClick={this.bachTaskBefore}
                    >
                        {this.props.icon}
                        {this.props.btnName}
                    </Button>}
                {/*进度条*/}
                <Modal
                    maskClosable={false}
                    title={"批量操作"}
                    centered
                    visible={this.state.stepVisible}
                    footer={null}
                    closable={false}
                >
                    <Progress percent={this.state.percent} steps={this.state.step} status="active"/>
                    <div>{`正在批量${activityTypeName}，大约剩余${this.state.step}s`}</div>
                </Modal>
            </>
        )
    }
}

/*************************************************  批量操作开始  *************************************************************************/
/**
 * 初始化
 * @param param
 * @param buttonItem
 * @param msgCall
 * @param resCall
 */
Activiti.prototype.batchStart = function (param, options, functions, buttonItem, saveEveryOneFunction, endFunction, beforeEveryOne, msgCall, resCall) {
    let uuids = Object.keys(param);
    let uuidsCopy = JSON.parse(JSON.stringify(uuids));
    functions.valuesMapTemp = {};
    functions.valuesMapTemp.remarks = "";
    this.doOne(uuidsCopy, options, functions, buttonItem, saveEveryOneFunction, endFunction, beforeEveryOne, msgCall, resCall, true, param);
}

Activiti.prototype.doOne = function (uuids, options, functions, buttonItem, saveEveryOneFunction, endFunction, beforeEveryOne, msgCall, resCall, isFirst, param) {
    //通知开始走第几条数据了，进行相关操作
    if(typeof saveEveryOneFunction == "function") {
        beforeEveryOne(uuids[0]);
    }

    let remarksInputed = true;
    if (isFirst) {
        remarksInputed = false;
    }
    Activiti.createActivit({
        uuid: uuids[0],
        pojoName: options.pojoName,
        userAccount: options.userAccount,
        activitiConf: options.activitiConf,
        showBtnFlag: false,
        otherJs: options.otherJs,
        againFlag: options.againFlag,
        getText: options.getText,
        success: function () {
            activiti.render = function (data, call) {
                call.call(activiti);
            };
            activiti.getText = functions.getText;
            activiti.getChoose = functions.getChoose;
            activiti.batchFlag = true;
            activiti.valuesMapTemp.remarksInputed = remarksInputed;
            activiti.valuesMapTemp.remarks = functions.valuesMapTemp.remarks
            activiti.afterSave = function (activiti, call) {
                if(typeof saveEveryOneFunction === "function") {
                    console.log(param)
                    saveEveryOneFunction(activiti, call, param[uuids[0]])
                    return;
                }
                call.call(activiti, param[uuids[0]])
            };
            activiti.getActivitiKey = functions.getActivitiKey;
            activiti.endFunction = function (activiti, call) {  //流程推进后的回调一般用作推进后修改状态
                console.log(activiti)
                let statusName = activiti.options.statusNameTemp;
                endFunction(statusName, activiti, call);
            }
            activiti.error = function (res) {
                functions.valuesMapTemp.remarks = activiti.actForm.values.otherData ? activiti.actForm.values.otherData.remarks : "";
                console.log("error");
                console.log(res);
                console.log("error uuid:" + activiti.options.uuid);
                msgCall({
                    code: -1,
                    uuid: activiti.options.uuid,
                    msg: "已处理完毕！"
                })
                if (uuids && uuids.length > 1) {
                    console.log("e uuids" + uuids);
                    activiti.doOne(uuids.splice(1, uuids.length), options, functions, buttonItem, saveEveryOneFunction, endFunction, beforeEveryOne, msgCall, resCall, false, param)
                } else {
                    resCall({code: 1, msg: "已处理完毕！"})
                }
            }
            activiti.successMsg = function (res) {
                functions.valuesMapTemp.remarks = activiti.actForm.values.otherData ? activiti.actForm.values.otherData.remarks : "";
                console.log("success");
                console.log(res);
                console.log("success uuid:" + activiti.options.uuid);
                msgCall({
                    code: 1,
                    uuid: activiti.options.uuid,
                    msg: "已处理完毕！"
                })
                // 如果不为空  则去掉第一个uuids组成新数组递归
                if (uuids && uuids.length > 1) {
                    console.log("uuids" + uuids);
                    activiti.doOne(uuids.splice(1, uuids.length), options, functions, buttonItem, saveEveryOneFunction, endFunction, beforeEveryOne, msgCall, resCall, false, param)
                } else {
                    resCall({code: 1, msg: "已处理完毕！"})
                }
                console.log(res);
            }
            activiti.load = {
                start: function () {
                    window.loading.show();
                },
                end: function () {
                    window.loading.hide()
                }
            }
            activiti.submitOK = function () {

            }
        }
    }, function () {
        this.batchExecOtherJs.call(this, buttonItem)
    })
}

Activiti.prototype.batchExecOtherJs = function (item) {
    let activiti = this;
    var args = [];
    activiti.options.item = JSON.parse(JSON.stringify(item));
    //清空辅助参数
    activiti.auditorMapTemp = item.document.lineJavaScript.auditorMap;
    activiti.options.msgUserListTemp = [];
    activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [];
    args.push(function () {
        activiti.buttonClick.call(activiti, item)
    })
    Activiti.util.simpleChainedFn.apply(activiti, args);
}